<smrts-dialog title="Desfazer importação" [hasFootnote]="true">

  @if (dados) {
    <div class="content custom-table">
      <div class="dados-lote">
        <span><strong>Arquivo:</strong> {{ dados.nomeArquivo }}</span>
        <span><strong>Importado em:</strong> {{ dados.dataCadastro | date:'dd/MM/yyyy HH:mm' }}</span>
      </div>
      @if (existeLancamentoConciliado) {
        <div class="aviso-conciliado inline-element">
          <i class="pi pi-info-circle"></i>
          <span>Não é possível desfazer esta importação: existem lançamentos dela que já foram conciliados. Desfaça a conciliação antes de proceder.</span>
        </div>
      }
      <p-table [value]="dados.lancamentos" dataKey="id" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]">
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="data">Data<p-sortIcon field="data" /></th>
            <th pSortableColumn="nome">Lançamento<p-sortIcon field="nome" /></th>
            <th pSortableColumn="valor">Valor<p-sortIcon field="valor" /></th>
            <th pSortableColumn="conciliado">Conciliado<p-sortIcon field="conciliado" /></th>
          </tr>
        </ng-template>
        <ng-template #body let-lancamento>
          <tr>
            <td>{{ lancamento.data | date:'dd/MM/yyyy' }}</td>
            <td>{{ lancamento.nome }}</td>
            <td>{{ lancamento.valor | currency:'BRL' }}</td>
            <td>
              <mat-checkbox [ngModel]="lancamento.conciliado" [disabled]="true"></mat-checkbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  <div footnote class="inline-element footnote">
    <button class="accent-text-button btn-cancelar" mat-button [mat-dialog-close]="false">
      Cancelar
    </button>
    <button class="white-text-button" mat-flat-button [disabled]="!dados || existeLancamentoConciliado" (click)="desfazerClick()">
      Desfazer importação
    </button>
  </div>
</smrts-dialog>
